export const MY_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'DD/MM/YY',
    monthYearLabel: 'DD MMMM YYYY',
    dateA11yLabel: 'DD/MM/YY',
    monthYearA11yLabel: 'DD MMMM YYYY'
  }
};

export const convertDateRangeToStartDate = (dateRange: string) => {
  if (!dateRange) return '';
  const cleaned = dateRange.replace(/\u00a0/g, ' ').trim();
  const [startDate] = cleaned.split('-').map((date) => date.trim());

  const [day, month, year] = startDate.split('/').map(Number);
  if (!day || !month || !year) return '';
  return new Date(Date.UTC(year, month - 1, day, 5, 0, 0, 0)).toISOString();
};

export const convertToLocalISO = (dateString: string) => {
  const date = new Date(dateString);

  // Extraer componentes de la fecha
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses empiezan en 0
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

  // Construir la cadena ISO local
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
};

export const buildGraphQLFields = (fields: string[]): string => {
  const tree: any = {};

  for (const field of fields) {
    const parts = field.split('.');
    let current = tree;

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      if (!current[part]) {
        current[part] = {};
      }
      current = current[part];
    }
  }

  const build = (node: Record<string, any>, indent = 2): string => {
    return Object.entries(node)
      .map(([key, value]) => {
        if (Object.keys(value).length === 0) {
          return ' '.repeat(indent) + key;
        } else {
          return (
            ' '.repeat(indent) +
            key +
            ' {\n' +
            build(value, indent + 2) +
            '\n' +
            ' '.repeat(indent) +
            '}'
          );
        }
      })
      .join('\n');
  };
  return build(tree);
};
